import React, { useCallback, useEffect, useLayoutEffect, useState, useRef } from "react";
import {
  Box,
  Text,
  Button,
  Layer,
  FormField,
  RadioButtonGroup
} from "grommet";
import "./ReassignMedicalKitSidebar.css";
import close from "../../../../../../assets/close_small (1).svg";
import MedicalKitService from "../../../../../../services/medical-kit/medical-kit.service";
import { useStore } from "../../../../../../Hooks/useStore";
import { observer } from "mobx-react";
import { FlightService } from "../../../../../../services/flights/flight.service";
import { APIs } from "../../../../../../util/api/APIs.tsx";
import SafeairManager from "../../../../../../util/api/SafeairManager";

const ReassignMedicalKitSidebar = ({ onClose, kitData }) => {
  const { rootStore } = useStore();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [apiResponseData, setApiResponseData] = useState([]);
  const [expiryDates, setExpiryDates] = useState([]);
  const [filteredFlightList, setFilteredFlightList] = useState([]);
  const [originalFlightList, setOriginalFlightList] = useState([]);
  const [selectedKit, setSelectedKit] = useState("");
  const [refurbishmentDueDate, setRefurbishmentDueDate] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    getFlights();
  }, []);

  const getFlights = async () => {
    try {
      const Flights = await FlightService.listFlights();
      setFilteredFlightList(Flights);
      setOriginalFlightList(Flights);
    } catch (error) {
      console.error("Error fetching flights:", error);
    }
  };

  useEffect(() => {
    // initialize expiryDates when apiResponseData changes
    if (apiResponseData.length > 0) {
      const initial = apiResponseData.map((item) => ({
        itemId: item.id,
        expiryDate: "",
      }));
      setExpiryDates(initial);
    }
  }, [apiResponseData]);

  const handleDateChange = (itemId, date) => {
    setExpiryDates((prev) =>
      prev.map((item) => (item.itemId === itemId ? { ...item, expiryDate: date } : item))
    );
  };

  const handleCheckboxChange = (option) => {
    setSelectedOptions((prevSelected) => {
      const isSelected = prevSelected.some((sel) => sel.value === option.value);
      const updated = isSelected
        ? prevSelected.filter((sel) => sel.value !== option.value)
        : [...prevSelected, option];
      const ids = updated.map((opt) => opt.value).join(",");
      rootStore.medicalKitStore.handleFlightNo(ids);
      return updated;
    });
  };

  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filteredList = filteredFlightList.filter((f) =>
    f.tailNumber.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const apiCall = async (kitType) => {
    setSelectedKit(kitType);
    try {
      const apiConfig = {
        api: APIs.Form.showMedicalKitData,
        parameters: { kitType },
        body: null,
      };
      const res = await SafeairManager.invoke(apiConfig);
      setApiResponseData(res.data);
    } catch (error) {
      console.error("Error fetching kit details:", error);
    }
  };

  const handleReassign = async () => {
    if (!rootStore.medicalKitStore.getFlightNo) {
      rootStore.notificationToastStore.showNotification("Please select flight number.", true, 3000);
      return;
    }

    const flightNumbers = rootStore.medicalKitStore.getFlightNo.split(",");
    console.log("flightNumbers", flightNumbers);
    try {
      const apiConfig = {
        api: APIs.Form.reassignMedicalKit, // define this in APIs.tsx
        parameters: {
          "kitId": kitData.id,
          "flightId": flightNumbers[0]
        },
        body: null,
      };

      const res = await SafeairManager.createMedical(apiConfig);
      if (res) {
        rootStore.notificationToastStore.showNotification("Medical kit reassigned successfully.", false, 3000);
        rootStore.medicalKitStore.handleupdate();
        onClose();
      }
    } catch (error) {
      rootStore.notificationToastStore.showNotification("Failed to reassign medical kit.", true, 3000);
      console.error("Reassign error:", error);
    }
  };

  return (
    <Layer
      full="vertical"
      position="right"
      onClickOutside={onClose}
      onEsc={onClose}
      style={{ borderRadius: "12px 0 0 12px", zIndex: 1000, width: "700px" }}
    >
      <Box className="create-kit-sidebar" background="light-1" elevation="medium" fill="vertical">
        <div className="create-kit-header-container">
          <div className="header" style={{padding:"0px"}}>
            <Box>
              <Text className="title">Reassign Medical Kit</Text>
              <p className="description">**Please update the flight and kit details.**</p>
            </Box>
            <Button className="close-btn" onClick={onClose}>
              <img src={close} alt="close" /> Close
            </Button>
          </div>
        </div>

        <Box style={{ padding: "16px 20px" }}>
          <form onSubmit={(e) => e.preventDefault()}>
            <Box direction="column" gap="medium" style={{ width: "80%" }}>
              {/* Flight number */}
              <FormField name="flightNumber" className="label" style={{ width: "80%" }}>
                <label className="labels">Flight Number</label>
                <div ref={dropdownRef} style={{ position: "relative" }}>
                  <input
                    type="text"
                    value={selectedOptions.map((opt) => opt.label).join(", ")}
                    onClick={toggleDropdown}
                    readOnly
                    placeholder="Please Select Flight"
                    style={{ width: "100%", height: "50px" }}
                  />
                  {isDropdownOpen && (
                    <div
                      style={{
                        width: "100%",
                        position: "absolute",
                        top: "50px",
                        zIndex: 11,
                        background: "#fff",
                        borderRadius: "8px",
                        border: "1px solid #ccc",
                      }}
                    >
                      <input
                        type="text"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        placeholder="Search Flights"
                        style={{
                          width: "100%",
                          padding: "8px",
                          borderRadius: "8px 8px 0 0",
                          border: "1px solid #ccc",
                          marginBottom: "5px",
                        }}
                      />
                      <div
                        style={{
                          maxHeight: "150px",
                          overflowY: "auto",
                          background: "#fff",
                        }}
                      >
                        {filteredList.length > 0 ? (
                          filteredList.map((org) => (
                            <div key={org.id} style={{ padding: "8px", display: "flex", alignItems: "center" }}>
                              <input
                                id={`checkbox-${org.id}`}
                                type="checkbox"
                                checked={selectedOptions.some((sel) => sel.value === org.id)}
                                onChange={() => handleCheckboxChange({ label: org.tailNumber, value: org.id })}
                                style={{ marginRight: "8px" }}
                              />
                              <label htmlFor={`checkbox-${org.id}`} style={{ cursor: "pointer" }}>
                                {org.tailNumber}
                              </label>
                            </div>
                          ))
                        ) : (
                          <div style={{ padding: "8px" }}>No results found</div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </FormField>
              {/* Refurbishment Date */}
              {/* 
              <FormField name="refurbishmentDueDate" className="label" style={{ width: "80%" }}>
                <label className="labels">Refurbishment Due Date</label>
                <input
                  type="date"
                  value={refurbishmentDueDate}
                  onChange={(e) => setRefurbishmentDueDate(e.target.value)}
                  style={{ width: "100%", height: "50px", padding: "5px", borderRadius: "4px", border: "1px solid #ddd" }}
                />
              </FormField>
              */}
            </Box>
          </form>
          <div className="btn-outer" style={{ marginTop: "40px" }}>
            <Button
              className="reset"
              type="reset"
              label="Reset"
              onClick={() => {
                rootStore.medicalKitStore.handleFlightNo("");
                setSelectedKit("");
                setApiResponseData("");
                setExpiryDates({});
                setSelectedOptions([]);
              }}
              style={{
                display: "flex",
                width: "120px",
                padding: "14px 49px",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
                borderRadius: "10px",
                background: "#357EFF",
                color: "#FFF",
                fontFamily: "Inter",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "24px",
              }}
            />
            <Button
              className="save"
              type="submit"
              // label={isAnyCheckboxSelected ? "Save" : "Create"}
              label="Reassign"
              onClick={handleReassign}
              style={{
                display: "flex",
                width: "120px",
                marginLeft: "10px",
                padding: "14px 49px",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
                borderRadius: "10px",
                background: "#357EFF",
                color: "#FFF",
                fontFamily: "Inter",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "24px",
              }}
            />
          </div>
        </Box>
      </Box>
    </Layer>
  );
};

export default observer(ReassignMedicalKitSidebar);
